import React, { useState, useRef } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Alert,
} from "@mui/material";
import api from "../../api/api";

function SubscriptionModal({ open, onClose, onSubscriptionExtended }) {
  const [selectedPlan, setSelectedPlan] = useState(30); // По умолчанию 30 дней
  const [debugMode, setDebugMode] = useState(false); // Дебаг-режим

  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);
  const submitting = useRef(false);

  const handlePlanChange = (event) => {
    setSelectedPlan(Number(event.target.value));
  };

  const handleDebugToggle = () => {
    setDebugMode(!debugMode);
  };

  const handleExtendSubscription = async () => {
    if (submitting.current) return;
    setError("");
    if (debugMode) {
      alert(`Подписка успешно продлена на ${selectedPlan} дней (ДЕБАГ)!`);
      onSubscriptionExtended(); // Обновляем данные профиля локально
      onClose(); // Закрываем модальное окно
      return;
    }

    submitting.current = true;
    setPending(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("Войдите в аккаунт заново");
        return;
      }

      const response = await api.post(
        `/founder/extend-subscription?days=${selectedPlan}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Подписка продлена:", response.data);
      alert(`Подписка успешно продлена на ${selectedPlan} дней!`);
      onSubscriptionExtended(); // Обновляем данные профиля
      onClose(); // Закрываем модальное окно
    } catch (error) {
      setError("Не удалось продлить подписку. Повторите попытку.");
    } finally {
      submitting.current = false;
      setPending(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: "8px",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Продление подписки
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <RadioGroup value={selectedPlan} onChange={handlePlanChange}>
          <FormControlLabel
            value={30}
            control={<Radio />}
            label="30 дней - 500₽"
          />
          <FormControlLabel
            value={180}
            control={<Radio />}
            label="180 дней - 2500₽"
          />
          <FormControlLabel
            value={360}
            control={<Radio />}
            label="360 дней - 4500₽"
          />
        </RadioGroup>
        <FormControlLabel
          control={
            <Checkbox checked={debugMode} onChange={handleDebugToggle} />
          }
          label="Без оплаты (дебаг)"
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleExtendSubscription}
          disabled={pending}
          style={{ marginTop: "20px" }}
        >
          Подтвердить
        </Button>
        <Button variant="text" color="secondary" fullWidth onClick={onClose}>
          Отмена
        </Button>
      </Box>
    </Modal>
  );
}

export default SubscriptionModal;
